// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import * as serviceSelectors from './selectors';
import * as serviceActions from './actions';

import * as Formatters from '../ui/Formatters';

import * as MessageFormat from './MessageFormat';
import LinkedText from '../ui/LinkedText';

const styles = theme => ({
  ...MessageFormat.styles(theme),
});


/*
 * Format for CS initiated request
 */
class TaskFormat extends Component {
  render() {
    /* eslint-disable */
    const { classes, message } = this.props;

    return (
      <div className={classes.formatTop}>
        <div className={classes.messageSender}>
          Assist Request -  {message.taskStatus}
        </div>
        <div className={classes.taken}>
          {Formatters.formatDateTime(message.taken)}
        </div>
        {/* <div className={classes.taken}>
          Reference ID: {message.messageId}
        </div>
        <div className={classes.taken}>
          Contact Description: {message.contactDescription}
        </div> */}
        
        <MuiCore.Divider style={{marginTop: 15, marginBottom: 15}}/>

        <div className={classes.sectionHeader} style={{ whiteSpace: 'pre'}}>
          Request
        </div>

        <div className={classes.fieldData}>
          <LinkedText value={message.request}
                      onClick={this.props.openContactLink}/>          
        </div>
        
        
        
        <div className={classes.sectionHeader} style={{marginTop: 20, marginBottom: 10}}>
          Request Details
        </div>

        <MuiCore.Grid item>
          <div className={classes.fieldData}>
            Agent: {message.taskAgent}
          </div>
          {/* <div className={classes.fieldData}>
            {message.taskAgent}
          </div> */}
        </MuiCore.Grid>
        
        
        <MuiCore.Grid>
          <MuiCore.Grid item>
            <div className={classes.fieldData}>
              Submitted: {Formatters.formatDateTime(message.taskStartTime)}
            </div>
            {/* <div className={classes.fieldData}>
              {Formatters.formatDateTime(message.taskStartTime)}
            </div> */}
          </MuiCore.Grid>
          
          <MuiCore.Grid item>
            <div className={classes.fieldData}>
              Completed: {Formatters.formatDateTime(message.taskEndTime)}
            </div>
            {/* <div className={classes.fieldData}>
              {Formatters.formatDateTime(message.taskEndTime)}
            </div> */}
          </MuiCore.Grid>
          
          <MuiCore.Grid item xs={4}>
            <div className={classes.fieldData}>
              Billable Agent Minutes: {message.billableAgentMinutes}
            </div>
            {/* <div className={classes.fieldData}>
              {message.billableAgentMinutes}
            </div> */}
          </MuiCore.Grid>
        </MuiCore.Grid>

        <MessageFormat.MessageStatus
          message={message}
          sectionHeaderClass={classes.sectionHeader}
          fieldLabelClass={classes.fieldLabel}
          fieldDataClass={classes.fieldData}/>       
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    message : serviceSelectors.getMessage(state),
  });
};

const mapDispatchToProps = {
  openContactLink : serviceActions.openContactLink,
};

export default connect(mapStateToProps,
                       mapDispatchToProps)(withStyles(styles)(TaskFormat));

